<template>
  <div class="panel">
    <!-- <vue-element-loading spinner="bar-fade-scale" color="#8f00d6" text="Enviando ..." duration="1.0" size="64" :active="isActive" :is-full-screen="false"/> --> 
    <div class="divload" v-if="isActive" >
        <h4 style=" color: rgb(162, 91, 102); position: fixed; margin-top: 100px;">Enviando ...</h4>
        <pulse-loader  :loading="loading" :color="color" :size="size"></pulse-loader>
    </div>
    <form-wizard
      title="Gas en casa"
      subtitle="Siempre que lo necesites"
      back-button-text="Anterior"
      next-button-text="Siguiente"
      finish-button-text="Ordenar"
      step-size="xs"
      color="#763693"
      @on-complete="onComplete"
    >
      <tab-content
        title="Localidad"
        :before-change="validar_tab_1"
        icon="ti-map-alt"
      >
        <div class="cont_wis">
          <div class="column one div_telefono" v-if="this.precio.telefono">
            <h4 class="tit_tel">
              Teléfono :
              <a :href="`tel:${this.precio.telefono}`">
                <span class="text_tel">{{ this.precio.telefono }}</span>
              </a>
            </h4>
          </div>

          <h5>Selecciona tu localidad</h5>
          <div class="column one m_t">
            <select
              class="input_control"
              v-model="form.estado_id"
              @change="get_estados"
            >
              <option value="" hidden>Selecciona tu estado</option>
              <option
                v-for="estado in page.estados"
                :value="estado.id"
                :key="estado.id"
                >{{ estado.nombre }}</option
              >
            </select>
            <span v-if="error.estado_id" class="error"
              >El campo es requerido</span
            >
          </div>
          <div class="column one m_t">
            <pulse-loader v-if="cargador" :loading="loading" :color="color" :size="size"></pulse-loader>
            <select v-else
              class="input_control"
              v-model="form.ciudad_id"
              @change="get_precio"
            >
              <option value="" hidden>Selecciona tu ciudad</option>
              <option
                v-for="ciudad in ciudades"
                :value="ciudad.id"
                :key="ciudad.id"
                >{{ ciudad.nombre }}</option
              >
            </select>
            <span v-if="error.ciudad_id" class="error"
              >El campo es requerido</span
            >
          </div>
        </div>
      </tab-content>
      <tab-content
        title="Cantidad"
        :before-change="validar_tab_2"
        icon="ti-money"
      >
        <div class="cont_wis">
          <div class="column one div_telefono" v-if="this.precio.telefono">
            <h4 class="tit_tel">
              Teléfono :
              <a :href="`tel:${this.precio.telefono}`">
                <span class="text_tel">{{ this.precio.telefono }}</span>
              </a>
            </h4>
          </div>
          <br />
          <div class="row_btn column one" v-if="ver_pocions">
            <div class=" one-second text-center div_btn">
              <button
                type="button"
                class="btn btn-succes btn_select1"
                @click="form.type = 1"
              >
                <img :src="'./img/cil.png'" alt="" /> <br />
                Cilindro
              </button>
            </div>
            <div class=" one-second text-center div_btn" @click="form.type = 2">
              <button type="button" class="btn btn-succes btn_select2">
                <img :src="'./img/tan.png'" alt="" /> <br />
                Estacionario
              </button>
            </div>
          </div>
          <div class="div_listros" v-if="form.type == 2">
            <div class="column one txt_lit text-center" style="margin: 0 1% 10px;">
              <h4>
                Costo por litro : <br />
                {{ precio.costo_litro | dinero }} mxn.
              </h4>
            </div>
            <div class="column one-second" style="margin: 0 1% 19px;">
              <label>Cantidad en pesos mxn </label>
              <input
                type="text"
                class="input_control"
                v-model="form.cantidad_pesos"
                placeholder="Ejemplo 500.00"
                @keyup="calcular"
              />
              <span v-if="error.cantidad_pesos" class="error"
                >El campo es requerido</span
              >
            </div>
            <div
              class="column one-second text-center"
              style="margin: 0 1% 19px;"
            >
              <label>Litros a comprar </label>
              <H4 class="lts"> {{ form.cantidad_litros | doble }} Lts.</H4>
            </div>
          </div>
          <div class="div_cilindros" v-if="form.type == 1">
              <div class="column one-second" style="margin: 0 1% 19px;">

            <label>Selecciona la capacidad </label>
            <select
              class="input_control"
              @change="calcular_cilindro"
              v-model="cilindro_select"
            >
              <option hiden value=""> Selecciona una opción</option>
              <option
                v-for="(cilindro, index) in precio_cilindro"
                :value="++index"
                :key="cilindro.id"
                @change="calcular_cilindro"
                >{{ cilindro.nombre }}</option
              >
            </select>
            <span v-if="error.cilindro" class="error"
              >El campo es requerido</span
            >
            </div>
            <div
              class="column one-second text-center"
              style="margin: 0 1% 19px;"
            >
              <label>Cantidad a pagar </label>
              <H4 class="lts"> $ {{ data_cilinidro.precio | doble }} mxn.</H4>
            </div>
          </div>
        </div>
      </tab-content>
      <tab-content title="Datos de entrega" icon="ti-direction-alt">
        <div class="cont_wis">
          <div class="column one div_telefono" v-if="this.precio.telefono">
            <h4 class="tit_tel">
              Teléfono :
              <a :href="`tel:${this.precio.telefono}`">
                <span class="text_tel">{{ this.precio.telefono }}</span>
              </a>
            </h4>
          </div>
          <div class="column m_b one-second">
            <input
              type="text"
              v-model="form.nombre"
              class="input_control"
              placeholder="Nombre y Apellidos"
            />
            <span v-if="error.nombre" class="error">El campo es requerido</span>
          </div>
          <div class="column m_b one-second">
            <input
              type="text"
              placeholder="Teléfono"
              class="input_control"
              v-model="form.telefono"
              @keyup="reg_telefono"
              maxlength="10"
            />
            <span v-if="error.telefono" class="error"
              >El campo es requerido</span
            >
            <span v-if="error.telefono_valido" class="error"
              >Un número de 10 digitos</span
            >
          </div>
          <div class="column m_b one">
            <input
              type="text"
              placeholder="Correo"
              class="input_control"
              v-model="form.correo"
            />
            <span v-if="error.correo" class="error">El campo es requerido</span>
            <span v-if="error.correo_valido" class="error"
              >Ingresa un correo valido</span
            >
          </div>
          <div class="column m_b one ">
            <textarea
              placeholder="Dirección"
              class="input_control"
              v-model="form.direccion"
            ></textarea>
            <span v-if="error.direccion" class="error"
              >El campo es requerido</span
            >
          </div>
          <div class="column m_b one">
            <vue-recaptcha
              :sitekey="kc"
              :loadRecaptchaScript="true"
              @verify="onVerify"
            ></vue-recaptcha>
            <span v-if="error.captcha" class="error"
              >El captcha es requerido</span
            >
          </div>
        </div>
      </tab-content>
    </form-wizard>
  </div>
</template>
<script>
import Page from "../point/Page.js";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import axios from "axios";
import "./filters.js";
import VueRecaptcha from "vue-recaptcha";
import { PulseLoader } from 'vue-spinner/dist/vue-spinner.min.js'

export default {
  components: {
    FormWizard,
    TabContent,
    VueRecaptcha,
    PulseLoader,
  },
  data: function() {
    return {
      page: new Page(),
      ciudades: {},
      sub: "",
      kc: kc,
      isActive: false,
      precio: {
        costo_litro: 0
      },
      cilindro_select: "",
      data_cilinidro: {
        id: "",
        precio: 0,
        litros: 0
      },
      cargador:false,
      precio_cilindro: {},
      ver_pocions: false,
      validateRecaptcha: false,
      color:"#800d23",
      size:"20px",
      form: {
        pagina_id: pge,
        type: "",
        estado_id: "",
        ciudad_id: "",
        cantidad_pesos: "",
        cantidad_litros: 0,
        nombre: "",
        telefono: "",
        correo: "",
        direccion: "",
        cilindro: ""
      },
      error: {
        estado_id: false,
        ciudad_id: false,
        cantidad_pesos: false,
        nombre: false,
        telefono: false,
        correo: false,
        direccion: false,
        captcha: false,
        cilindro: false,
        correo_valido: false,
        telefono_valido: false
      }
    };
  },
  mounted: function() {
    this.page.get_estados();
  },
  methods: {
    onVerify: function(response) {
      if (response) this.validateRecaptcha = true;
    },
    calcular_cilindro: function() {
      if (this.cilindro_select != "") {
        let index = this.cilindro_select;
        this.data_cilinidro = this.precio_cilindro[--index];
        this.form.cilindro = this.data_cilinidro.id;
      } else {
        this.data_cilinidro = { id: "", precio: 0, litros: 0 };
        this.form.cilindro = "";
      }
    },
    subtit: function() {
      this.m = "";
      this.m = "¡ Pídelo ahora !";
      if (precio.telefono) {
        this.m += "<br>" + precio.telefono;
      }
    },
    get_estados: function() {
      this.cargador = true;
      axios
        .post(`${hst}json/ciudades`, {
          pagina_id: pge,
          estados: this.form.estado_id
        })
        .then(
          function(response) {
            this.ciudades = response.data;
            this.form.ciudad_id = "";
            this.cargador = false;

          }.bind(this)
        )
        .catch(function(error) {
          console.log(error);
        });
    },
    get_precio: function() {
      axios
        .post(`${hst}json/precios`, {
          pagina_id: pge,
          estado: this.form.estado_id,
          ciudad: this.form.ciudad_id
        })
        .then(
          function(response) {
            this.precio = response.data.litros;
            this.precio_cilindro = response.data.cilindros;
            if (this.precio_cilindro.length > 0) {
              this.ver_pocions = true;
              this.form.type = "";
            } else {
              this.ver_pocions = false;
              this.form.type = 2;
            }
          }.bind(this)
        )
        .catch(function(error) {
          console.log(error);
        });
    },
    realizar_pedido: function() {
      let form = this.form;
      this.isActive = true;
      axios
        .post(`${hst}json/realizar_pedido`, {
          form
        })
        .then(
          function(response) {
            this.isActive = false;
            if (response.data.type == "exito") {
              this.$swal({
                title: "Tu pedido ha sido registrado.",
                text: response.data.mensaje,
                icon: "success",
                allowOutsideClick: false
              }).then(function() {
                location.reload();
              });
            } else {
              this.$swal({
                title: "Error",
                text: response.data.mensaje,
                icon: "error",
                allowOutsideClick: false
              }).then(function() {
                // location.reload();
              });
            }
          }.bind(this)
        )
        .catch(function(error) {
          console.log(error);
        });
    },
    calcular: function() {
      let valor = parseInt(this.form.cantidad_pesos);
      if (isNaN(valor)) {
        this.form.cantidad_pesos = "";
      } else {
        this.form.cantidad_pesos = parseInt(this.form.cantidad_pesos);
      }
      if (this.form.cantidad_pesos != "") {
        let calculo = this.form.cantidad_pesos / this.precio.costo_litro;
        this.form.cantidad_litros = calculo;
      } else {
        this.form.cantidad_litros = 0;
      }
    },
    reg_telefono: function() {
      let valor = parseInt(this.form.telefono);
      if (isNaN(valor)) {
        this.form.telefono = "";
      } else {
        this.form.telefono = parseInt(this.form.telefono);
      }
    },
    validate_mail: function() {
      let email = this.form.correo;
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validar_tab_1: function() {
      let vlid = true;
      if (this.form.estado_id == "") {
        this.error.estado_id = true;
        vlid = false;
      } else {
        this.error.estado_id = false;
      }
      if (this.form.ciudad_id == "") {
        this.error.ciudad_id = true;
        vlid = false;
      } else {
        this.error.ciudad_id = false;
      }
      return vlid;
    },
    validar_tab_2: function() {
      let vlid = true;
      if (this.form.type == 2) {
        if (this.form.cantidad_pesos == "") {
          this.error.cantidad_pesos = true;
          vlid = false;
        } else {
          this.error.cantidad_pesos = false;
        }
      }else{
         if (this.form.cilindro == "") {
          this.error.cilindro = true;
          vlid = false;
        } else {
          this.error.cilindro = false;
        }
      }
      return vlid;
    },
    onComplete: function() {
      let vlid = true;
      let con_tel = this.form.telefono.toString().length;
      if (this.form.nombre == "") {
        this.error.nombre = true;
        vlid = false;
      } else {
        this.error.nombre = false;
      }
      if (this.form.telefono == "") {
        this.error.telefono = true;
        vlid = false;
      } else {
        this.error.telefono = false;
        if (con_tel != 10) {
          this.error.telefono_valido = true;
          vlid = false;
        } else {
          this.error.telefono_valido = false;
        }
      }
      if (this.form.correo == "") {
        this.error.correo = true;
        vlid = false;
      } else {
        this.error.correo = false;
        if (this.validate_mail()) {
          this.error.correo_valido = false;
        } else {
          this.error.correo_valido = true;
          vlid = false;
        }
      }
      if (this.form.direccion == "") {
        this.error.direccion = true;
        vlid = false;
      } else {
        this.error.direccion = false;
      }
      if (this.validateRecaptcha == false) {
        this.error.captcha = true;
        vlid = false;
      } else {
        this.error.captcha = false;
      }
      if (vlid) {
        this.realizar_pedido();
      }
      return vlid;
    }
  }
};
</script>
<style>
.panel {
  background-color: #ffffff;
  padding: 10px;
  border-radius: 5px;
  margin-top: 80px;
}
.error {
  color: red;
}
select {
  margin-bottom: 5px;
  width: 100% !important;
}
input {
  margin-bottom: 5px !important;
  width: 100% !important;
}

textarea {
  margin-bottom: 5px !important;
  width: 100% !important;
}
.m_b {
  margin-bottom: 10px;
}
.lts {
  color: #000;
  margin-bottom: 30px;
}
.txt_lit h4 {
  color: #000;
  margin-bottom: 15px;
}
.text-center {
  text-align: center;
}

.vue-form-wizard .wizard-title {
  color: #522975 !important;
  font-size: 45px;
  font-weight: 600;
  line-height: 30px;
}

.vue-form-wizard .category {
  color: #522975 !important;
  font-size: 18px !important;
  font-weight: 600;
  margin-top: 15px;
  margin-bottom: 15px;
  line-height: 25px;
}

.cont_wis {
  height: 100%;
  display: flow-root;
  padding: 10px;
  border-radius: 5px;
  -webkit-box-shadow: -1px 4px 20px 0px rgba(136, 136, 136, 0.89);
  box-shadow: -1px 4px 20px 0px rgba(136, 136, 136, 0.89);
  margin: 10px 0px 30px 0px;
}

.input_control {
  margin-top: 15px;
  padding: 7px;
  border: 0px !important;
  border-bottom: 2px solid #848484 !important;
  background-color: #fff !important;
}

.input_control:focus {
  background-color: #fff;
  border: 0px;
  border-bottom: 2px solid #848484;
  background-color: #522975 imp !important;
}

.m_t {
  margin-bottom: 10px;
}

.btn_select1{
    padding: 20px 45px 20px 45px;
    font-size: 14px;
}
.btn_select2{
    padding: 20px 30px 20px 30px;
    font-size: 14px;
}

@media screen and (max-width: 768px) {
  .panel {
    margin-top: 70px;
  }
  iframe {
    transform: scale(0.69);
    transform-origin: 0 0;
  }

  .btn_select1{
    padding: 20px 20px 20px 20px;
    font-size: 14px;
  }

  .btn_select2{
      padding: 20px 10px 20px 10px;
      font-size: 14px;
  }

}

.vue-form-wizard .wizard-btn {
  min-width: 110px;
}
.tit_tel {
  color: #000;
}
.text_tel {
  font-weight: 700;
  color: #800d23;
}
.div_telefono {
  text-align: center;
  margin: 15px 0px !important;
}
.div_btn {
  width: 50% !important;
}
.row_btn {
  display: flex;
}

.velmld-overlay{
  z-index: 5 !important;
}

.vue-form-wizard .wizard-tab-content{
  padding: 0px 20px 0px;
}

.vue-form-wizard {
    padding-bottom: 5px;
}
.divload{
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0.7;
  background-color: #fff;
  z-index: 701;
}
.cont_wis{
  margin: 10px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/FormPedido.vue